import { z } from 'zod/v4';
import { ToolCategory, ToolName, ToolPolicy, ToolWeight } from '../types.js';
const inputSchema = z.object({});
const outputSchema = z.object({
    workflowName: z.string().nullable(),
    currentStageLabel: z.string().nullable(),
    nextStep: z
        .object({
        label: z.string(),
        scheduledFor: z.iso.datetime().nullable(),
        isManual: z.boolean(),
    })
        .nullable(),
    isPaused: z.boolean(),
});
export const getWorkflowTool = {
    name: ToolName.GetWorkflow,
    category: ToolCategory.CaseInfo,
    weight: ToolWeight.Light,
    version: 1,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: "Read the case's current workflow stage and what the workflow plans to do next. Use this to avoid proposing an action the workflow is already scheduled to take on its own.",
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=get-workflow.js.map